<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="w1200" >
            <v-breadcrumb value1="首页" value2="了解廉江" value3="节庆活动" :url="url"></v-breadcrumb>
        </div>

        <div class="container" id="container" v-if="datalist.list.length>0">


            <div class="listH2"  >民俗文化</div>




            <div class="container_box ">

                <div class="container_box_left " >
                    <img class="hover" style="width: 100%;" :src="datalist.list[0].coverImageUrl" @click="toDetail(datalist.list[0].path)">
                    <div class="title hover">{{datalist.list[0].title}}</div>
                    <p class="hover">
                        {{datalist.list[0].summary}}
                    </p>
                    <a href="javascript:;"  @click="toDetail(datalist.list[0].path)">了解更多</a>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist.list" v-if="0<j&&j<5" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="5<datalist.list.length && datalist.list.length<=13">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="13<datalist.list.length && datalist.list.length<=21">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <button class="pages" @click="loadPage()" v-if="(datalist.totalCount - datalist.pageSize*datalist.currentPage)>0">剩余{{datalist.totalCount - datalist.pageSize*datalist.currentPage}}项,展开更多</button>
        </div>


        <div class="container" id="container1"  v-if="datalist2.list.length>0">
                <div class="listH2"  >节庆活动</div>
                <div class="container_box ">

                    <div class="container_box_left " >
                        <img class="hover" style="width: 100%;" :src="datalist2.list[0].coverImageUrl" @click="toDetail(datalist2.list[0].path)">
                        <div class="title hover">{{datalist2.list[0].title}}</div>
                        <p class="hover">
                            {{datalist2.list[0].summary}}
                        </p>
                        <a href="javascript:;"  @click="toDetail(datalist2.list[0].path)">了解更多</a>
                    </div>
                    <div class="container_box_right ">
                        <div class="item " v-for="(i,j) in datalist2.list" v-if="0<j&&j<5" >
                            <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                            <div  class="title hover">{{i.title}}</div>
                            <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="container_box mt20" v-if="5<datalist2.list.length && datalist2.list.length<=13">
                    <div class="container_box_right " style="margin-right: 30px">
                        <div class="item " v-for="(i,j) in datalist2.list" v-if="4<j&&j<9" >
                            <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                            <div  class="title hover">{{i.title}}</div>
                            <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                        </div>
                    </div>
                    <div class="container_box_right ">
                        <div class="item " v-for="(i,j) in datalist2.list" v-if="8<j&&j<13" >
                            <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                            <div  class="title hover">{{i.title}}</div>
                            <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                        </div>
                    </div>
                </div>
                <div class="container_box mt20" v-if="13<datalist2.list.length && datalist2.list.length<=21">
                    <div class="container_box_right " style="margin-right: 30px">
                        <div class="item " v-for="(i,j) in datalist2.list" v-if="4<j&&j<9" >
                            <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                            <div  class="title hover">{{i.title}}</div>
                            <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                        </div>
                    </div>
                    <div class="container_box_right ">
                        <div class="item " v-for="(i,j) in datalist2.list" v-if="8<j&&j<13" >
                            <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                            <div  class="title hover">{{i.title}}</div>
                            <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                        </div>
                    </div>
                </div>
                <button class="pages" @click="loadPage2()" v-if="(datalist2.totalCount - datalist2.pageSize*datalist2.currentPage)>0">剩余{{datalist2.totalCount - datalist2.pageSize*datalist2.currentPage}}项,展开更多</button>

        </div>


        <div class="container"  style="margin-bottom: 20px" v-if="datalist3.list.length>0">
            <img class="whyc" src="../../assets/img/whyc.png">
            <div class="whH2">
                <img src="../../assets/img/wzlj/left.png" style="left: 0">
                <img src="../../assets/img/wzlj/right.png" style="right:0">
                非物质文化遗产</div>
            <div class="listH2"  >省级保护名录</div>
            <div class="container_box ">

                <div class="container_box_left " >
                    <img class="hover" style="width: 100%;" :src="datalist3.list[0].coverImageUrl" @click="toDetail(datalist3.list[0].path)">
                    <div class="title hover">{{datalist3.list[0].title}}</div>
                    <p class="hover">
                        {{datalist3.list[0].summary}}
                    </p>
                    <a href="javascript:;"  @click="toDetail(datalist3.list[0].path)">了解更多</a>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist3.list" v-if="0<j&&j<5" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="5<datalist3.list.length && datalist3.list.length<=13">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist3.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist3.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="13<datalist3.list.length && datalist3.list.length<=21">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist3.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist3.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <button class="pages" @click="loadPage3()" v-if="(datalist3.totalCount - datalist3.pageSize*datalist3.currentPage)>0">剩余{{datalist3.totalCount - datalist3.pageSize*datalist3.currentPage}}项,展开更多</button>
        </div>


        <div class="container"  style="margin-bottom: 20px" v-if="datalist4.list.length>0">
            <div class="listH2"  >市级保护名录</div>
            <div class="container_box ">
                <div class="container_box_left " >
                    <img class="hover" style="width: 100%;"  :src="datalist4.list[0].coverImageUrl" @click="toDetail(datalist4.list[0].path)">
                    <div class="title hover">{{datalist4.list[0].title}}</div>
                    <p class="hover">
                        {{datalist4.list[0].summary}}
                    </p>
                    <a href="javascript:;"  @click="toDetail(datalist4.list[0].path)">了解更多</a>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist4.list" v-if="0<j&&j<5" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="5<datalist4.list.length && datalist4.list.length<=13">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist4.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist4.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <div class="container_box mt20" v-if="13<datalist4.list.length && datalist4.list.length<=21">
                <div class="container_box_right " style="margin-right: 30px">
                    <div class="item " v-for="(i,j) in datalist4.list" v-if="4<j&&j<9" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
                <div class="container_box_right ">
                    <div class="item " v-for="(i,j) in datalist4.list" v-if="8<j&&j<13" >
                        <img class="hover" :src="i.coverImageUrl" @click="toDetail(i.path)">
                        <div  class="title hover">{{i.title}}</div>
                        <a href="javascript:;" class="index_more" @click="toDetail(i.path)">了解更多</a>
                    </div>
                </div>
            </div>
            <button class="pages" @click="loadPage4()" v-if="(datalist4.totalCount - datalist4.pageSize*datalist4.currentPage)>0">剩余{{datalist4.totalCount - datalist4.pageSize*datalist4.currentPage}}项,展开更多</button>
        </div>





        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'廉江概览',
                        url:'#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cabebd0006'
                    },
                    {
                        name:'廉江动态',
                        url:'#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91caf27c0007'
                    },
                    {
                        name:'节庆活动',
                        url:'#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb31640008'
                    },
                    {
                        name:'音画廉江',
                        url:'#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb9d910009'
                    }
                ],


                datalist:null,
                pageSize:5,
                currentPage:1,

                datalist2:null,
                pageSize2:5,
                currentPage2:1,

                datalist3:null,
                pageSize3:5,
                currentPage3:1,

                datalist4:null,
                pageSize4:5,
                currentPage4:1,




            }
        },
        watch:{
            $route:function (newValue) {
                this.ljcode = this.$route.query.ljcode;
                this.columnId = this.$route.query.columnId;
                this.rootColumnId = this.$route.query.rootColumnId;
                this.url = ['jqhd',this.rootColumnId,this.columnId];
                this.getList();
                this.getList2();
                this.getList3();
                this.getList4();

            }
        },
        created() {

            this.ljcode = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = ['jqhd',this.rootColumnId,this.columnId];
            this.getList();
            this.getList2();
            this.getList3();
            this.getList4();

        },

        methods:{
            loadPage(){
                this.pageSize += 8;
                if((this.datalist.totalCount - this.datalist.pageSize*this.datalist.currentPage)>0){
                    this.getList();
                }

            },
            getList(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=${this.pageSize}&currentPage=${this.currentPage}&ywqx=8a9a9d807332981d017332bfdd800000`
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data;
                    data.list.forEach(v=>{
                        v.coverImageUrl = apiimg+(v.coverImageUrl?v.coverImageUrl:'');
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`

                    });
                    this.datalist = data;
                    console.log(this.datalist)
                })
            },

            loadPage2(){
                this.pageSize2 += 8;
                if((this.datalist2.totalCount - this.datalist2.pageSize*this.datalist2.currentPage)>0){
                    this.getList2();
                }

            },
            getList2(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=${this.pageSize2}&currentPage=${this.currentPage2}&ywqx=8a9a9d807332981d017332c009160001`
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data;
                    data.list.forEach(v=>{
                        v.coverImageUrl = apiimg+(v.coverImageUrl?v.coverImageUrl:'');
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`

                    });
                    this.datalist2 = data;
                })
            },

            loadPage3(){
                this.pageSize3 += 8;
                if((this.datalist3.totalCount - this.datalist3.pageSize*this.datalist3.currentPage)>0){
                    this.getList3();
                }

            },
            getList3(){
                let that = this;
                let url = `${api}/api/cms/article/list?ywqx=8a9a9d8073d621d20173db3d3cf70208`
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data;
                    data.list.forEach(v=>{
                        v.coverImageUrl = apiimg+(v.coverImageUrl?v.coverImageUrl:'');
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`
                    });
                    this.datalist3 = data;
                })
            },

            loadPage4(){
                this.pageSize4 += 8;
                if((this.datalist4.totalCount - this.datalist4.pageSize*this.datalist4.currentPage)>0){
                    this.getList4();
                }

            },
            getList4(){
                let that = this;
                let url = `${api}/api/cms/article/list?ywqx=8a9a9d8073d621d20173db3d82df020c`
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data;
                    data.list.forEach(v=>{
                        v.coverImageUrl = apiimg+(v.coverImageUrl?v.coverImageUrl:'');
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`
                    });
                    this.datalist4 = data;
                })
            },


            toDetail(v){
                this.$router.push({path:`/detail2?${v}`})
            }

        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }

    .container_box{
        display: flex;

        &_left{
            width: 585px;
            height: 582px;
            margin-right: 29px;
            position: relative;
            .title{
                height:19px;
                font-size:18px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin: 20px 0 24px 0 ;
            }
            p{
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:24px;
            }
            a{
                display: inline-block;
                color: #666666;
                width: 60px;
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                border-bottom:2px solid #666666;
                position: absolute;
                bottom: 0;
            }
            a:hover{
                width: 70px;
                font-size: 16px;
            }
        }
        &_right{
            float: right;
            width: 585px;
            height: 582px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: space-between;
            .item{
                img{
                    width: 278px;
                    height: 185px;
                }
                .title{
                    height:19px;
                    font-size:18px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    margin: 20px 0 24px 0 ;
                }
                a{
                    display: inline-block;
                    color: #666666;
                    width: 4.5em ;
                    font-size: 14px;
                    height: 32px;
                    line-height: 32px;
                    border-bottom:2px solid #666666;
                }
                a:hover{
                    width: 65px;
                    font-size: 16px;
                }

            }
        }

    }

    .pages{
        width:300px;
        height:40px;
        border:1px solid rgba(102, 102, 102, 1);
        font-size:16px;
        font-weight:400;
        color:rgba(0,0,0,1);
        margin: 50px 0 90px 0;
        position: relative;
        left: 50%;
        transform: translateX(-50%);

    }

    #container2{
        margin-bottom: 30px;
    }

    .whyc{
        display: block;
        margin: 0 auto;
        width: 60px;
        height: 60px;
        margin-top: 40px;
    }
    .whH2{
        position: relative;
        img{
            width: 400px;
            position: absolute;
            top:50%;
            transform:translateY(-50%);
        }
        height:48px;
        font-size:48px;
        font-weight:400;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 22px 0 55px 0;
    }



</style>
